import cai_can from '../../assets/img/cai_can.png'
import coin_4 from '../../assets/img/coin_4.png'
import coin_5 from '../../assets/img/coin_5.png'
import flower_bg from '../../assets/img/flower_bg.png'
import cai_bua from '../../assets/img/cai_bua.png'

const FlashPage = () => {

    return (
        <div className="main-login">
            <div className="fixed top-[15%] left-[50%] w-full translate-x-[-50%] z-[10]">
                <div className="px-[30px]">
                    <div className='title-main'>
                        UWIN
                    </div>
                </div>
            </div>
            <div className="fixed w-full top-[10%] left-[6%]">
                <img src="../assets/images/coin.png" className="" />
            </div>
            <div className="fixed top-[10%] left-[0%]">
                <img src="../assets/images/Frame.png" className="" style={{width: "415px"}}/>
            </div>
            <div className="fixed w-full top-[30%] left-[60%]">
                <img src="../assets/images/coin_3.png" className="" />
            </div>
            <div className="fixed z-[1] w-full blend-mode top-[18%] left-[6%]">
                <img src="../assets/images/Light.png" className="blink-effect" />
            </div>
            <div className="fixed z-[20] w-full blend-mode top-[23%] left-[23%]">
                <img src="../assets/images/Light.png" className="blink-effect" />
            </div>
            <div className="fixed z-[20] w-full blend-mode top-[18%] left-[70%]">
                <img src="../assets/images/Light.png" className="blink-effect" />
            </div>
            <div className="bg-coin-loading">
                <img src="../assets/images/coin-bg.png" />
            </div>
            <div className="fixed z-[20] w-full top-[40%] left-[20%] blend-mode">
                <img src={cai_can} />
            </div>
            {/* <div class="fixed z-[20] w-full top-[10%] left-[20%] blend-mode">
                <img src={cai_bua} />
            </div> */}
            <div className="fixed z-[20] w-full top-[50%] left-[0%] blend-mode">
                <img src={flower_bg} />
            </div>
            <div className="fixed z-[20] w-full top-[80%] left-[10%] blend-mode">
                <img src={coin_4} />
            </div>
            <div className="fixed z-[20] w-full top-[70%] left-[80%] blend-mode">
                <img src={coin_5} />
            </div>
        </div>
    );
}

export default FlashPage;